import { DailyAgendaActionFactory, DailyAgendaActions } from '../actions';

export const createOnSlotClickAction: DailyAgendaActionFactory<
  DailyAgendaActions['onSlotClick']
> =
  ({ setState, getState, flowAPI }) =>
  async (slotId) => {
    console.log('onSlotClick', slotId);
  };
